import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { formatLastSeen } from 'helpers/formatLastSeen';
import { getEntityLink } from 'helpers/getEntityLink';
import { accessLevels } from 'constants/accessLevels';
import { Dropdown } from 'components/Dropdown';
import { Tooltip } from 'components/Tooltip';
import { Button } from 'components/Button';
import styles from 'pages/Users/Users.scss';

export const UserRow = ({
  user: { id, surname, name, email, role, locations: userLocations },
  locations,
  setChangedRoles,
  setChangedLocations,
  toggleSelection,
  index,
  status,
}) => {
  const originalRole = accessLevels.find(({ value }) => value === role);
  const [currentRole, setCurrentRole] = useState(originalRole);
  const { user } = useSelector((state) => state.auth);

  const [locationsOptions, setLocationsOptions] = useState([]);
  const [currentLocation, setCurrentLocation] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (role === 3 || !locations.length) return;

    const studioOptions = locations
      .filter(({ type }) => type === 'studio')
      .map(({ id, name }) => ({ label: name, value: [id] }));

    const branchIDs = locations.filter(({ type }) => type === 'affiliate').map(({ id }) => id);

    const supplementedOptions = [...studioOptions];
    if (branchIDs?.length > 0) {
      supplementedOptions.push({ label: 'Філії', value: branchIDs });
    }

    setLocationsOptions(supplementedOptions);

    const originalLocation = supplementedOptions.find(({ value }) =>
      value.some((val) => userLocations.map(({ id }) => id).includes(val))
    );
    setCurrentLocation(originalLocation);
  }, [locations, userLocations]);

  const handleChangeRole = (value) => {
    setCurrentRole(value);
    setChangedRoles((prev) => {
      if (value.value !== originalRole.value) {
        return { ...prev, [id]: value.value };
      } else {
        const { [id]: _, ...rest } = prev;
        return rest;
      }
    });
  };

  const handleChangeLocation = (value) => {
    setCurrentLocation(value);
    setChangedLocations((prev) => {
      if (!value) {
        return { ...prev, [id]: null };
      }

      if (!userLocations.includes(value.value)) {
        return { ...prev, [id]: value.value };
      } else {
        const { [id]: _, ...rest } = prev;
        return rest;
      }
    });
  };

  return (
    <>
      <td onClick={() => toggleSelection(id)}>{index + 1}</td>
      <td className={styles.nameCell}>
        <span className={cn(styles.status, { [styles.active]: status?.isOnline })}>
          <Tooltip className={styles.statusTooltip} text={status?.isOnline ? 'Онлайн' : 'Офлайн'} position='right' />
        </span>
        <Button
          className={styles.link}
          onClick={() => navigate(getEntityLink(`users/${id}`))}
          disabled={user?.role !== 3}
          noStyle
        >
          {surname} {name}
        </Button>
      </td>
      <td className={styles.emailCell}>
        <Button
          className={styles.link}
          onClick={() => navigate(getEntityLink(`users/${id}`))}
          disabled={user?.role !== 3}
          noStyle
        >
          {email}
        </Button>
      </td>
      <td className={cn({ [styles.dropdown]: user?.role === 3 && user?.id !== id })}>
        {user?.role < 3 || user?.id === id ? (
          accessLevels.find(({ value }) => value === role)?.label
        ) : (
          <Dropdown
            options={accessLevels}
            value={currentRole}
            onChange={handleChangeRole}
            clearable={false}
            tableCellStyle
          />
        )}
      </td>
      <td className={cn({ [styles.dropdown]: user?.role === 3 && user?.id !== id })}>
        {user?.role === 3 && user?.id !== id
          ? role < 3 &&
            locationsOptions.length > 0 && (
              <Dropdown
                placeholder='Оберіть локацію'
                options={locationsOptions}
                value={currentLocation}
                onChange={handleChangeLocation}
                tableCellStyle
              />
            )
          : locationsOptions.find(({ value }) => value.some((val) => userLocations.map(({ id }) => id).includes(val)))
              ?.label}
      </td>
      <td>{status?.isOnline ? 'Зараз' : status?.lastSeen && formatLastSeen(status?.lastSeen)}</td>
    </>
  );
};
